import React from 'react';
import { createPortal } from 'react-dom';
import { Tooltip } from 'react-tooltip';

const TOOLTIP_Z_INDEX = 10050;

type PortaledTooltipProps = React.ComponentProps<typeof Tooltip>;

export default function PortaledTooltip({
    style,
    positionStrategy = 'fixed',
    ...props
}: PortaledTooltipProps) {
    if (typeof document === 'undefined') {
        return null;
    }

    return createPortal(
        <Tooltip
            positionStrategy={positionStrategy}
            style={{ zIndex: TOOLTIP_Z_INDEX, ...style }}
            {...props}
        />,
        document.body,
    );
}
